export default "__VITE_ASSET__bpD1l$Iu__"